// dashboard\src\utils\helpers.ts
import {ApiResponse} from '../types';

export const createResponse = <T>(
    data: T,
    status: number = 200,
    success: boolean = true
): Response => {
    const response: ApiResponse<T> = {success, data};
    return new Response(JSON.stringify(response), {
        status,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    });
};

export const createErrorResponse = (
    error: string,
    status: number = 500
): Response => {
    // ✅ لازم تضيف data: null لأنها required
    const response: ApiResponse<null> = {
        success: false,
        error,
        data: null  // <-- أضف هذا السطر
    };
    return new Response(JSON.stringify(response), {
        status,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    });
};

export const generateId = (): string => {
    return crypto.randomUUID();
};

export const corsHeaders = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
};

// هذي دوال للـ frontend فقط، مو مستخدمة في backend
export const formatUSD = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount)
}

export const formatLBP = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'LBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount).replace('LBP', 'LL')
}

export const formatDate = (date: string): string => {
    return new Date(date).toLocaleDateString('ar-LB', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })
}

export const formatPhone = (phone: string): string => {
    if (!phone) return ''
    const cleaned = phone.replace(/\D/g, '')
    return cleaned.startsWith('961') ? `+${cleaned}` : `+961${cleaned}`
}

export const truncateId = (id: string, length: number = 8): string => {
    if (!id) return ''
    return id.length > length ? `${id.slice(0, length)}...` : id
}

export const getRelativeTime = (date: string): string => {
    const now = new Date()
    const then = new Date(date)
    const diff = now.getTime() - then.getTime()

    const minutes = Math.floor(diff / 60000)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (minutes < 1) return 'الآن'
    if (minutes < 60) return `منذ ${minutes} دقيقة`
    if (hours < 24) return `منذ ${hours} ساعة`
    if (days < 7) return `منذ ${days} يوم`

    return formatDate(date)
}

export const formatNumberWithCommas = (x: number | string): string => {
    if (x === null || x === undefined) return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}